import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { ConnectedRouter } from 'connected-react-router';
import { load } from 'dotenv';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { ThemeProvider } from 'styled-components';
import MainTheme from './Theme';

import ReactGA from 'react-ga';
declare const COMMITHASH: string;
declare const SENTRY_DSN: string;

if (COMMITHASH && SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    autoSessionTracking: true,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

ReactGA.initialize('UA-156080589-1');

ReactGA.pageview(window.location.pathname + window.location.search);

load();
import App from './containers/App';

import LanguageProvider from './containers/LocaleSettings/LocaleProvider';
import * as enMessages from './translations/en.json';

import * as deMessages from './translations/de.json';

import { localeSettingsChangeLocale, localeSettingsLoadMessages } from './containers/LocaleSettings/actions';
import registerServiceWorker from './registerServiceWorker';

import configureStore from './configureStore';
import './assets/stylesheets/index.scss';
import { PersistGate } from 'redux-persist/integration/react';

const history = createBrowserHistory();
const { store, persistor } = configureStore({}, history);

const getLocale = () => {
  if (navigator.language) {
    return navigator.language.split(/[-_]/)[0];
  } else {
    return 'en';
  }
};

store.dispatch(
  localeSettingsLoadMessages({
    en: enMessages,
    de: deMessages,
  }),
);

store.dispatch(localeSettingsChangeLocale(getLocale()));

ReactDOM.render(
  <Provider store={store}>
    <LanguageProvider>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={MainTheme}>
          <ConnectedRouter history={history}>
            <App />
          </ConnectedRouter>
        </ThemeProvider>
      </PersistGate>
    </LanguageProvider>
  </Provider>,
  document.getElementById('root') as HTMLElement,
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx